import React, { useCallback, useEffect, useState } from 'react'
import camelcaseKeys from 'camelcase-keys'
import dayjs from 'dayjs'

import reserveApi from '../../../utils/axios'

import { AdminHeader } from '../Index'
import { AdminTd, AdminTh, AdminTable } from '../Tables'

// Create our number formatter.
const dollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
})

const percent = new Intl.NumberFormat('en-US', {
  style: 'percent',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2 // (causes 2500.99 to be printed as $2,501)
})

export const Summary = ({ short, userId = null }) => {
  const [summary, setSummary] = useState({ all: [], user: [] })

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/admin/payments/table/monthly',
      params: {}
    }).then(response => {
      setSummary(camelcaseKeys(response.data, { deep: true }))
    })
  }, [userId])

  const firstPayment = useCallback(
    date => {
      return summary.user.filter(s => s.date === date && s.userCount === 1)[0]
    },
    [summary]
  )

  return (
    <div>
      {!short && <AdminHeader>Payments by Month</AdminHeader>}

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Month</AdminTh>
            <AdminTh>Count</AdminTh>
            <AdminTh>$</AdminTh>
            <AdminTh>First</AdminTh>
            <AdminTh>F$</AdminTh>
            <AdminTh>F%</AdminTh>
            <AdminTh>Repeat</AdminTh>
            <AdminTh>R$</AdminTh>
          </tr>
        </thead>
        {summary.all.map((obj, index) => (
          <tr key={index} className={index % 2 !== 0 && 'bg-gray-50'}>
            <AdminTd>{dayjs(obj.date).format('MM-YYYY')}</AdminTd>
            <AdminTd>{obj.count}</AdminTd>
            <AdminTd>
              {dollars.format(obj.total)}
              <span className="ml-2 text-xs text-gray-400">{dollars.format(obj.average)}</span>
            </AdminTd>
            <AdminTd>{firstPayment(obj.date).count}</AdminTd>
            <AdminTd>
              {dollars.format(firstPayment(obj.date).total)}
              <span className="ml-2 text-xs text-gray-400">{dollars.format(firstPayment(obj.date).average)}</span>
            </AdminTd>
            <AdminTd>{percent.format(firstPayment(obj.date).count / obj.count)}</AdminTd>

            <AdminTd>{obj.count - firstPayment(obj.date).count}</AdminTd>
            <AdminTd>
              {dollars.format(obj.total - firstPayment(obj.date).total)}

              <span className="ml-2 text-xs text-gray-400">
                {dollars.format(
                  (obj.total - firstPayment(obj.date).total) / (obj.count - firstPayment(obj.date).count)
                )}
              </span>
            </AdminTd>
          </tr>
        ))}
      </AdminTable>
    </div>
  )
}

export default Summary
